module.exports = __webpack_public_path__ + "7dce7e10d6ec97d259e2b5788256e20e.pdf";